import { html } from './utils';

const mainMenu = () => {

  // Model

  let open = false;
  let subMenuOpen = false;

  // Views

  const body = document.body;
  const el = document.querySelector('[data-control="header"]');
  const button = el.querySelector('.c-IconButton');
  const buttonImage = button.querySelector('img');
  const mainMenu = el.querySelector('.c-MainMenu');
  const menuItems = el.querySelectorAll('.c-MainMenu__item');

  // Event Listeners

  const toggleMainMenu = () => {
    open = !open;

    // toggle body scroll
    body.classList.toggle('u-no-scroll-sm', open);

    // toggle the header
    el.classList.toggle('c-Header--open', open);

    // swap button image
    toggleImage(buttonImage, open);
  };

  const onMenuItemClick = (evt) => {
    const menuItem = evt.target.parentNode;
    const subMenu = menuItem.querySelector('.c-SubMenu');

    if (subMenuOpen) {
      evt.preventDefault();
      return;
    }

    subMenuOpen = true;

    if (! subMenu) {
      return;
    }

    evt.preventDefault();
    subMenu.classList.add('c-SubMenu--open');

    menuItems.forEach(node => {
      if (node !== menuItem) {
        node.classList.add('u-hidden-sm')
      }

      if (node === menuItem) {
        node.classList.add('u-display-background-none')
      }
    });

    const overlay = makeOverlay();
    subMenu.appendChild(overlay);
    overlay.addEventListener('click', () => {
      close();
    });

    const back = makeBack();
    mainMenu.insertBefore(back, mainMenu.firstChild);
    back.addEventListener('click', (evt) => {
      evt.preventDefault();
      close();
    });

    const close = () => {
      menuItems.forEach(node => {
        node.classList.remove('u-hidden-sm')
        node.classList.remove('u-display-background-none')
      });

      subMenu.classList.remove('c-SubMenu--open');
      back.remove();
      overlay.remove();
      subMenuOpen = false;
    };
  };

  button.addEventListener('click', toggleMainMenu);
  [...menuItems].forEach(node => {
    const link = node.querySelector('a');
    link.addEventListener('click', onMenuItemClick);
  });
};

const toggleImage = (node, open = false) => {
  const { openSrc, closedSrc } = node.dataset;
  node.src = open ? openSrc : closedSrc;
};

const makeBack = () => html(`
  <li class="c-MainMenu__item u-visible-sm c-MainMenu__item--arrow-left">
    <a href="#" style="padding-left: 30px">Back</a> 
  </li>
`);

const makeOverlay = () => html(`
  <div class="u-overlay"></div>
`);

export default mainMenu;



// WEBPACK FOOTER //
// ./themes/app/assets/js/mainMenu.js